function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-2-3h16v16H-2z"
}), React.createElement("path", {
  d: "M0 .333v9.334h12V.333H0zm3.553 8h-2.22V1.667h2.22v6.666zm3.56 0h-2.22V5.667h2.22v2.666zm3.554 0h-2.22V5.667h2.22v2.666zm0-4h-5.78V1.667h5.78v2.666z",
  fill: "#323C47"
}));

var SvgIconLayouts = function SvgIconLayouts(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 10
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon_layouts.5bce79f4.svg";
export { SvgIconLayouts as ReactComponent };